import React, {useEffect, useRef, useState} from "react";
import { connect } from "react-redux";

import { INTERNAL_LINKS } from "enum";
import { Spin } from "antd";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

import IconLoading from "images/icon-loading.gif";
import { useHistory } from "react-router-dom";
import { homeSelector } from "redux/selectors/homeSelector";
import { ModalCompleteYourProfile } from "components";

import {
  CustomModal
} from "components";
import { setMembresyForCode, getUser, confirmStatusPaid,confirmStatusPaid2, setBulSettingLicences } from "redux/actions/home-actions";

const PostMessageComponent = ({checkSession,setMembresyForCode, getUser, confirmStatusPaid,confirmStatusPaid2, userProfile,location, setBulSettingLicences}) => {

  const [modalResponsePay, setModalResponsePay] = useState("")
  const { refreshCorporateAdmin, refreshCorporateAdmin2 } = queryString.parse(location.search);
  const [shouldPremium, setShouldPremium] = useState(false)
  const [loading, setLoading] = useState(false);
  const [bulCompleteProfile, setBulCompleteProfile] = useState(false);
  
  const { search } = useLocation();
  const query = new URLSearchParams(search);

  const history = useHistory();
  const completeProfile = query?.get("completeProfile");

  const clock = useRef(null)
  const clock2 = useRef(null)

  useEffect(() => {
    if((completeProfile === true || completeProfile === 'true') && userProfile?.id){
      if (!userProfile?.completed || userProfile?.percentOfCompletion !== 100) {
        setBulCompleteProfile(true);
        history.push(window.location.pathname);
      }
    }
  },[completeProfile, userProfile])

  useEffect(() => {
    if ((refreshCorporateAdmin === 'true' || refreshCorporateAdmin === true) && (userProfile?.email !== '' && userProfile?.email)) {
      getUser();
      setModalResponsePay("Wowza! You are now a PREMIUM MEMBER of the Hacking HR LAB! 🎉")
      confirmStatusPaid(userProfile?.email,userProfile)
      history.push(window.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCorporateAdmin,userProfile]);

  
  useEffect(() => {
    if ((refreshCorporateAdmin2 === 'true' || refreshCorporateAdmin2 === true) && (userProfile?.email !== '' && userProfile?.email)) {
      getUser();
      confirmStatusPaid2()
      setShouldPremium(true)
      setModalResponsePay("Wowza! You are now a PREMIUM MEMBER of the Hacking HR LAB! 🎉")
      history.push(window.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCorporateAdmin2,userProfile]);

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  useEffect(() => {
    if (window.rewardful) { window.rewardful('ready', () => {}); }
    const viaCookie = getCookie('via');
    
    console.log(getCookie('via'));
    if (viaCookie) {
      const url = new URL(window.location.href);
      if (!url.searchParams.get('via')) {
        url.searchParams.set('via', viaCookie);
        window.history.replaceState({}, '', url.toString());
      }
    }
  }, []);

  useEffect(() => {
    if(shouldPremium && userProfile.memberShip !== 'premium'){
      setShouldPremium(false)
      setTimeout(() => {
        confirmStatusPaid2()
      }, 1000);
    }
  },[userProfile, shouldPremium])

  

  let bulCase = false

  useEffect(() => {
    const messagePage = (ev) => {
      let caseRegister = (ev.origin === process.env.REACT_APP_PUBLIC_DOMAIN_WWW || ev.origin === process.env.REACT_APP_PUBLIC_DOMAIN) 
        ? 'community-education-seo' 
        : (ev.origin === process.env.REACT_APP_PUBLIC_DOMAIN_PEOPLE_SUMMIT || ev.origin === process.env.REACT_APP_PUBLIC_DOMAIN_CONFERENCE2025 || 'http://localhost:3003') 
          ? 'ai-summit'
          : ''
        
      if (ev.origin === process.env.REACT_APP_PUBLIC_DOMAIN || ev.origin === process.env.REACT_APP_PUBLIC_DOMAIN_PEOPLE_SUMMIT || ev.origin === process.env.REACT_APP_PUBLIC_DOMAIN_CONFERENCE2025 || ev.origin === 'http://localhost:3003' || ev.origin === process.env.REACT_APP_PUBLIC_DOMAIN_WWW) {
        if(ev.data.code && ev.data.email){
          const {code, email, url} = ev.data
          if(clock.current){
            clearTimeout(clock.current)
          }
          if(!clock.current){
            localStorage.setItem('caseRedirection', url)
            checkSession(email,code,(bul, dat) => {
              setBulSettingLicences(dat ? true : false)
              if(dat && bul){
                setLoading(true)
                console.log({email,code:dat})
                setMembresyForCode({email,code:dat},(bulSS=false) => {
                  if(bulSS){
                    console.log("por aqui")
                    try{
                      // notification.success({
                      //   title: "Success",
                      //   description: "Membership assigned!!",
                      // });
                      setTimeout(() => {
                        localStorage.setItem("caseRegister", caseRegister)
                        if(url){
                          window.location.href = `${url}?refreshCorporateAdmin2=true`;
                        }else if(window.location.pathname !== INTERNAL_LINKS.HOME){
                          window.location.href = `${INTERNAL_LINKS.HOME}?refreshCorporateAdmin2=true`
                        }
                        setBulSettingLicences(false)
                      }, 800);
                    }catch(er){
                      console.log(er)
                    }
                  }
                  setLoading(false)
                }) 
              }else if(bul){
                localStorage.setItem("caseRegister", caseRegister)
                if(url){
                  window.location.href = url
                }else if(window.location.pathname !== INTERNAL_LINKS.HOME){
                  window.location.href = INTERNAL_LINKS.HOME
                }
              }
            })
          }
          let clockM = setTimeout(() => {
            clock.current = null ;  
          }, 800);
          clock.current = clockM 
        }else{
          if(!bulCase){
            if(clock2.current){
              clearTimeout(clock2.current)
            }
            clock2.current = setTimeout(() => {
              // eslint-disable-next-line react-hooks/exhaustive-deps
              bulCase = true;
              ((ev || {}).source || {postMessage: () => {}}).postMessage({ ready: true }, ev.origin);
            }, 600);
          }
        }
      }
    }
  
    window.addEventListener('message', (e) => messagePage(e));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return (<>
    {(loading === true) && (
        <div className="loading-container" style={{zIndex:'100000',position:'fixed',left:'0px',top:'0px'}}>
            <Spin indicator={<img src={IconLoading} alt="loading-img" />} />
        </div>
    )}
    <CustomModal
      visible={modalResponsePay !== ''}
      onCancel={() => {setModalResponsePay('')}}
      title={[]}
      footer={[]}
      width={480}
    >
      <p style={{margin:'0px',padding:'0px',marginTop:'10px',textAlign:'center',width:'100%', fontSize:'22px', fontWeight:'bold'}}>{modalResponsePay}</p>
      <p style={{margin:'0px',padding:'0px',marginTop:'30px',textAlign:'center',width:'100%', fontSize:'22px', fontWeight:'bold'}}>Thank you so much!</p>
    </CustomModal>
    {bulCompleteProfile && (
        <div className="complete-profile">
          <ModalCompleteYourProfile
            userProfile={bulCompleteProfile ? userProfile : {}}
            get={() => {getUser()}}
            setBulKnowRegister={(data) => {}}
            setBulCompleteProfile={setBulCompleteProfile}
            onClose={() => setBulCompleteProfile(false)}
          />
        </div>
      )}
  </>)
};


const mapStateToProps = (state) => ({
  userProfile: homeSelector(state).userProfile,
});

const mapDispatchToProps = {
  setMembresyForCode,
  getUser, 
  confirmStatusPaid,
  confirmStatusPaid2,
  setBulSettingLicences
};

export default connect(mapStateToProps, mapDispatchToProps)(PostMessageComponent);